import React from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';

const provider = new firebase.auth.GoogleAuthProvider();


export const login = () => {
  firebase.auth().signInWithPopup(provider);
};

export const logout = () => {
  firebase.auth().signOut();
};

export const useAuth = () => {
  const [state, setState] = React.useState(() => {
    const user = firebase.auth().currentUser;
    return {
      initializing: !user,
      user,
    };
  });
  function onChange(user) {
    setState({
      initializing: false,
      user,
    });
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  return state;
};


export const anonymousLogin = () => {
  firebase.auth().signInAnonymously();
};

export const isSignInWithEmailLink = () => {
  return firebase.auth().isSignInWithEmailLink(window.location.href);
};

export const signInWithEmailLink = ({ email }) => {
  return firebase.auth().signInWithEmailLink(email, window.location.href)
}